import StartEndDurationManager from "../../../gd/manager/start-end-duration/start-end-duration-manager"
import {ITEM_TYPE_TASK, ITEM_TYPE_EVENT, ITEM_TYPE_PROJECT} from "../../../gd/const/item"
import {getDatesForDependency} from "../../../model2/task/functions/display-dates"

export default function editDependencyLag(manager: any, dependency: any, newLagValue: number) {
    let userId
    switch (dependency.successor.type) {
        case ITEM_TYPE_TASK     : userId = dependency.successor.item.actionRequiredUserId; break
        case ITEM_TYPE_EVENT    : userId = dependency.successor.item.assignedToUserId; break
    }

    const getDates = (listItem:any) => listItem.getDatesForDependency ? listItem.getDatesForDependency() : getDatesForDependency(listItem.item)

    const newRange = new StartEndDurationManager().adjustWorkdaysDependencyLag(
        dependency.type,
        getDates(dependency.predecessor),
        getDates(dependency.successor),
        newLagValue,
        userId
    )

    switch (dependency.successor.type) {
        case ITEM_TYPE_TASK     :
        case ITEM_TYPE_PROJECT  :
            manager.setStartEnd(dependency.successor.id, newRange.start, newRange.end)
            break

        case ITEM_TYPE_EVENT    :

            switch (dependency.successor.item.type) {
                case gd.const.event.type.PROJECT_MILESTONE:
                    manager.setStartEnd(dependency.successor.id, newRange.start, null) //single date
                    break

                default:
                    manager.setStartEnd(dependency.successor.id, newRange.start, newRange.end)
                    break
            }
            break
    }
}